export default [
    {
      path: "/h5/trade-spot/:pairs?",
      name: "h5-trade-spot",
      component: () => import('@/pages/v2/h5/trade/trade-spot'),
    },
    {
      path: "/h5/user-center",
      name: "h5-user-center",
      component: () => import('@/pages/v2/h5/trade/h5-user-center'),
    },
  ]
  


// WEBPACK FOOTER //
// ./src/router/v2/h5/trade/index.js